import { call, put, takeLatest, all } from "redux-saga/effects";
import { showAlert } from "../../utility/alertHelper";

import {
  GLOBAL_AVAILABLE_CREDITS,
  LOAD_UPLOADED_FILES,
  LOAD_UPLOADED_DETAILS_SUCCEEDED,
  LOAD_UPLOADED_DETAILS_FAILED,
  START_BULK_VALIDATION,
  START_BULK_VALIDATION_SUCCEEDED,
  START_BULK_VALIDATION_FAILED,
  DOWNLOAD_REPORT,
  LOAD_SINGLE_EMAILS,
  LOAD_SINGLE_EMAILS_SUCCEEDED,
  DELETE_BULK_VALIDATION,
  DOWNLOAD_SINGLE_REPORT,
  BULK_RE_VALIDATION,
  BULK_RE_VALIDATION_FAILED,
  BULK_RE_VALIDATION_SUCCEEDED,
  SHOW_CONFIRMATION,
  BLOCKED_CREDITS,
  LOAD_COMPANY_PROFILE_SUCCESS,
  LOAD_COMPANY_PROFILE_ERROR,
  LOAD_COMPANY_PROFILE_INFO,
  SAVE_USER_COUNTRY,
  SAVE_USER_COUNTRY_SUCCESS
} from "../../common/constants";

import * as api from "../../services/EmailVerifiedFiles";
import history from "../../utility/history";
// function* loginSaga() {

//Worker saga
function* loadUploadedFile(action) {
  try {
    //console.log("Load Files Action : "+JSON.stringify(action));
    const result = yield call(api.getUploadedFiles, action.userdata);
    //console.log("Email Validation List" + JSON.stringify(result));
    //Write redirection logic here
    let hasMore = true;
    let skip = result.skip;
    let limit = 10;
    if (result.success) {
      const totalResults = result.totalResults;
      if (result.skip >= totalResults) {
        //console.log("Files length equal to total");
        hasMore = false;
        skip = skip;
      }
      if(!isNaN(result.available_credits)){
        yield put({
          type: GLOBAL_AVAILABLE_CREDITS,
          available_credits:result.available_credits
        })
      }

      if(!isNaN(result.blockedcredits)) {
        yield put({
          type: BLOCKED_CREDITS,
          blockedcredits: result.blockedcredits
        })
      }
      //console.log("Results Count : " + totalResults);
      //console.log("Loaded Results : " +JSON.stringify(result));
      //console.log("Loaded Successfully");
      yield put({
        type: LOAD_UPLOADED_DETAILS_SUCCEEDED,
        emailverificationinfo: result,
        totalResults: totalResults,
        timer: result.timer,
        hasMore,
        skip
      });
    } else {
    }
  } catch (error) {
    yield put({
      type: LOAD_UPLOADED_DETAILS_FAILED,
      args: {
        message: error.message
      }
    });
  }
}
function* startValidations(action) {
  try {
    ////console.log(JSON.stringify(action));
    const result = yield call(api.startBulkEmailValidation, action.fileData);
    //console.log("Result : " + JSON.stringify(result));
    if (result.success) {
      //console.log("Selected Index : " + action.selectedIndex);
      yield put({
        type: START_BULK_VALIDATION_SUCCEEDED,
        selectedIndex: action.selectedIndex
      });
    } else {
      const message = result.msg ?  result.msg : "Failed to Start Validation";
      if(result.showPopup) {
      yield put({type: SHOW_CONFIRMATION, selectedIndex: action.selectedIndex});
      } else {
      // validate from backend
      showAlert({
        msg_text: message,
        msg_type: result.msg_type
      });
      yield put({
        type: START_BULK_VALIDATION_FAILED,
        selectedIndex: action.selectedIndex
      });
    }
    }
  } catch (error) {}
}
function* reValidations(action) {
  try {
    const result = yield call(api.startBulkReEmailValidation, action.fileData);

    if (result.success) {
      // console.log("RE ------------------- Selected Index : " + action.selectedIndex);
      // console.log(" RE -----------------RESULT RE VALIDATION  : " +JSON.stringify (result));

      yield put({
        type: BULK_RE_VALIDATION_SUCCEEDED,
        selectedIndex: action.selectedIndex,
        emailverificationinfo: result.fileData
      });

      // window.location.reload();
    } else {
      const message = result.msg ? result.msg : "Failed to Create Re-validation Copy. ";
      showAlert({
        msg_text: message,
        msg_type: result.msg_type
      });
      yield put({
        type: BULK_RE_VALIDATION_FAILED,
        selectedIndex: action.selectedIndex
      });
    }
  } catch (error) {}
}

function* deleteFile(action) {
  try {
    //console.log(JSON.stringify(action));
    const result = yield call(api.deleteBulkEmailValidation, action.fileData);
    if (!result.success)
      showAlert({
        msg_text: "Failed to Delete",
        msg_type: "error"
      });
  } catch (error) {}
}
function* downLoadReport(action) {
  try {
    //console.log(JSON.stringify(action));
    const result = yield call(
      api.DownloadValidationReport,
      action.selectedData
    );
  } catch (error) {}
}
function* loadSingleEmails(action) {
  try {
    //console.log(JSON.stringify(action));
    const result = yield call(api.loadEmails, action.userdata);
    if (result.success) {
      if(!isNaN(result.available_credits)){
        yield put({
          type:GLOBAL_AVAILABLE_CREDITS,
          available_credits:result.available_credits
        })
      }
      if(!isNaN(result.blockedcredits)) {
        yield put({
          type: BLOCKED_CREDITS,
          blockedcredits: result.blockedcredits
        })
      }
      yield put({
        type: LOAD_SINGLE_EMAILS_SUCCEEDED,
        results: result.emails,
        data:{
          page: result.page,
          hasMore:result.hasMore,
          success:result.success,
          username:result.username,
          inprocess:result.inprocess,
          total:result.total,
          pages:result.pages
        }
      });
    }
  } catch (error) {}
}

function* downloadSingleEmails(action) {
  try {
    //console.log(JSON.stringify(action));
    const result = yield call(api.DownloadSingleEmailsReport, action.userDetails);
  } catch (error) {}
}


function* loadCompanyProfileDetails() {
  try {
    //console.log(JSON.stringify(action));
    const result = yield call(api.getCompanyProfileInfo);

    if(result.success) {
      yield put({
        type: LOAD_COMPANY_PROFILE_SUCCESS,
        payload: {
          showCountryPopup: result.data.hasCountry !== undefined ? !result.data.hasCountry: false,
          showPopup: result.data.showPopup ? true : false,
          timer: result.data.time,
          isOnlyMins: result.data.isOnlyMins,
          timeLapse: result.data.timeLapsed,
        }
      });
    } else {
      yield put({
        type: LOAD_COMPANY_PROFILE_ERROR,
        payload: "loading company profile config failed"
      });
    }


  } catch (error) {

  }
}


function* saveCountry(action) {
  const result = yield call(api.postCountry, action.country);

  if(result.success) {
    yield put({
      type: SAVE_USER_COUNTRY_SUCCESS
    });
    yield call(loadCompanyProfileDetails);
  } else {

  }
}

// listener Saga
function* loadUploadedFileDetails() {
  yield takeLatest(LOAD_UPLOADED_FILES, loadUploadedFile);
  yield takeLatest(START_BULK_VALIDATION, startValidations);
  yield takeLatest(BULK_RE_VALIDATION, reValidations);
  yield takeLatest(DOWNLOAD_REPORT, downLoadReport);
  yield takeLatest(LOAD_SINGLE_EMAILS, loadSingleEmails);
  yield takeLatest(DELETE_BULK_VALIDATION, deleteFile);
  yield takeLatest(DOWNLOAD_SINGLE_REPORT, downloadSingleEmails);
  yield takeLatest(LOAD_COMPANY_PROFILE_INFO, loadCompanyProfileDetails);
  yield takeLatest(SAVE_USER_COUNTRY, saveCountry);
}

//saga composition
//yield[call(onLogin)];
//}

export default function* uploadedFilesSaga() {
  //console.log("Saga called");
  yield [loadUploadedFileDetails()];
}



// WEBPACK FOOTER //
// ./src/Containers/EmailValidation/sagas.js